import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import { ISchedule } from '../../../../modules/apis/student/lesson/schedule/types'
import { n_book_lessons, n_weekly } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import useLessonsStore from '../../../../store/useLessonsStore'
import ScheduleItem from './ScheduleItem'

const ScheduleModalBody = ({
  schedules,
  setSchedules,
  handleSubmit,
  handleDelete,
}: {
  schedules: ISchedule[]
  setSchedules: Dispatch<SetStateAction<ISchedule[]>>
  handleSubmit: (skip?: boolean) => void
  handleDelete?: () => void
}) => {
  const matchingOption = useLessonsStore((state) => state.matchingOption)
  const setMatchingOption = useLessonsStore((state) => state.setMatchingOption)

  const { sendPageViewEvent } = useEventTracking()

  useEffect(() => {
    if (schedules.length > 0) {
      sendPageViewEvent({ page_name: 'selected_lesson_list' })
    }
  }, [schedules])

  const { t } = useTranslation()
  return (
    <div className="h-full bg-gray-100">
      <div className="cursor-pointer py-[14px] pl-[20px] sm:hidden" onClick={() => handleDelete()}>
        <QIcon_chevron_left width={24} height={24} />
      </div>
      <div className="Headline3-22Bd flex items-center justify-between p-[16px] sm:bg-white">
        <div>{t(n_book_lessons.selected_lessons)}</div>
      </div>
      <div className="flex flex-col gap-y-[16px] p-[16px]">
        {schedules.map((schedule, i) => {
          return (
            <ScheduleItem
              schedules={schedules}
              setSchedules={setSchedules}
              schedule={schedule}
              key={`schedule-${i}`}
              setMatchingOption={setMatchingOption}
              handleDeleteSchedule={handleDelete}
            />
          )
        })}
      </div>
      {schedules[0]?.selectedCoupon.isWeeklyLessonPackage && (
        <div className="px-[16px]">
          <div>
            <div className="Body2-14Bd texx-black">{t(n_weekly.tutor_matching.caption_title)}</div>
            <div className="Body2-14Md text-gray-700">{t(n_weekly.tutor_matching.caption_desc)}</div>
          </div>
        </div>
      )}
      <div className="fixed bottom-0 mt-[20px] w-full bg-white px-[16px] pt-[12px] pb-[34px] sm:relative sm:bg-gray-100">
        <div className="mt-[8px]">
          <DSButton
            disabled={!matchingOption}
            size={BUTTON_SIZE.LG}
            type={BUTTON_TYPE.SOLID}
            onClick={() => handleSubmit(false)}
          >
            <DSButton.Label>{t(n_book_lessons.booking_complete)}</DSButton.Label>
          </DSButton>
        </div>
      </div>
    </div>
  )
}
export default ScheduleModalBody
